import { clearAllInput, toggleHeight, doublePullDown, postWithCsrfAjax } from './functions/utilityFunctions';

// 絞り込みタブ：開いておくカテゴリタブは１つのみ　▼ここから
export const toggleContainerHeight = (element, containers, setHeight) => {
  const minHeight = setHeight ? setHeight : 0;

  element.addEventListener('click', () => {
    const targetId = element.getAttribute('data-target');
    const target = document.getElementById(targetId);

    if (target) {
      const isCurrentlyActive = element.classList.contains('is-active');

      if (isCurrentlyActive) {
        // 現在のヘッダーがアクティブでない場合は開く
        target.style.height = target.scrollHeight + 'px'; // コンテナを開く
        element.classList.add('is-active');
        target.classList.add('is-active');
      } else {
        // 現在のヘッダーがアクティブな場合は閉じる
        target.style.height = minHeight + 'px'; // コンテナを閉じる
        element.classList.remove('is-active');
        target.classList.remove('is-active');

        // 他のコンテナを閉じる
        containers.forEach((container) => {
          if (container !== target) {
            container.style.height = minHeight + 'px'; // 他のコンテナを閉じる
            const header = container.closest('li').querySelector('.c-bottom-nav__sort-tab');
            if (header) {
              header.classList.remove('is-active');
            }
            container.classList.remove('is-active');
            // 他のコンテナのチェックはリセットする
            clearAllInput(container);
            searchButtonDisabledToggle();
          }
        });
      }
    }
  });
};
// ▲ここまで

document.addEventListener('DOMContentLoaded', () => {
  window.handleTabClick = function (targetId, p1, p2) {
    const contentDiv = document.getElementById(targetId);
    // デバッグ
    // 選択されたタブに応じたAPIを呼び出す
    let apiUrl;
    switch (targetId) {
      case 'memory':
        if (p1 === null) {
          p1 = '2000';
        }
        apiUrl = `/api/bottom-navigation-memory?yyyy=${p1}`;
        break;
      case 'memoryData':
        apiUrl = `/api/bottom-navigation-memory-data?lrackname=${p1}&yyyy=${p2}`;
        break;
      case 'search':
        apiUrl = '/api/bottom-navigation-search';
        break;
      case 'taglist':
        apiUrl = '/api/bottom-navigation-taglist-all';
        break;
      case 'popularTagsList':
        apiUrl = `/api/bottom-navigation-taglist?tagflg=popular&ctgryCode=${p2}`;
        break;
      case 'newTagsList':
        apiUrl = `/api/bottom-navigation-taglist?tagflg=new&ctgryCode=${p2}`;
        break;
      case 'tagSearch':
        apiUrl = `/api/bottom-navigation-tag-search?word=${p2}`;
        break;
      default:
        return;
    }
    // AJAXをコール
    postWithCsrfAjax({
      url: apiUrl,
      type: 'GET',
      success: function (response) {
        if (targetId === 'memory') {
          // 思い出の作品
          const ctgryNameList = response.t1;
          const yyyyList = response.t2;

          if (ctgryNameList && yyyyList) {
            renderMemory('memory-select-container', 'memory-container', ctgryNameList, yyyyList);
            gwtMemory();
          } else {
            console.error('ctgryNameList or yyyyList is null');
          }
        } else if (targetId === 'memoryData') {
          // 思い出の作品更新
          const memoryList = response;
          renderMemoryData('memory-container', memoryList);
        } else if (targetId === 'search') {
          // 絞込み
          // カテゴリIDと名称のMapを取得
          const ctgryMap = response.t1;
          // カテゴリIDをキーとしてLrackのリスト(lrackcode,lrackname)を取得
          const lrackMap = response.t2;

          if (ctgryMap && typeof ctgryMap === 'object' && lrackMap && typeof lrackMap === 'object') {
            renderSearch('search-category', ctgryMap, lrackMap);
          } else {
            console.error('ctgryMap or lrackMap is null or not an object', { ctgryMap, lrackMap });
          }

          // 'search'タブが選択されたとき、「検索するボタンエリア」を表示
          const buttonsDiv = document.querySelector('.c-bottom-nav__buttons');
          if (buttonsDiv) {
            buttonsDiv.classList.add('is-active');
          }
        } else if (targetId === 'taglist') {
          // ネットオフのおすすめ
          // 人気タグ
          const topPopularTags = response.t1;
          // 新着タグ
          const topNewTags = response.t2;

          // 人気タグ処理
          if (topPopularTags && typeof topPopularTags === 'object') {
            renderTagList('popularTagsList', topPopularTags);
          } else {
            console.error('topPopularTags is null or not an object', { topPopularTags });
          }

          // 新着タグ処理
          if (topNewTags && typeof topNewTags === 'object') {
            renderTagList('newTagsList', topNewTags);
          } else {
            console.error('topNewTags is null or not an object', { topNewTags });
          }
        } else if (targetId === 'popularTagsList') {
          // 人気タグ
          const tagList = response;
          if (tagList && typeof tagList === 'object') {
            renderTagList('popularTagsList', tagList);
          } else {
            console.error('topPopularTagList is null or not an object', { tagList });
          }
        } else if (targetId === 'newTagsList') {
          // 新着タグ
          const tagList = response;
          if (tagList && typeof tagList === 'object') {
            renderTagList('newTagsList', tagList);
          } else {
            console.error('newTagsList is null or not an object', { tagList });
          }
        } else if (targetId === 'tagSearch') {
          // タグ検索
          const tagList = response;
          if (tagList && typeof tagList === 'object') {
            renderTagList('tagSearch', tagList);
          } else {
            console.error('tagSearch is null or not an object', { tagList });
          }
        }

        // 他のタブが選択されたときは「検索するボタンエリア」を非表示
        const buttonsDiv = document.querySelector('.c-bottom-nav__buttons');
        if (buttonsDiv) {
          if (targetId === 'search') {
            buttonsDiv.classList.add('is-active');
          } else {
            buttonsDiv.classList.remove('is-active');
          }
        }

        // プルダウン
        const pullDownButton = document.querySelectorAll('.js-navPullDown');
        if (pullDownButton.length > 0) {
          pullDownButton.forEach((button) => {
            toggleHeight(button, 0);
          });
        }

        // 二重のプルダウン
        const pullDown = document.querySelectorAll('.js-navDoublePullDownCommon');
        if (pullDown.length) {
          pullDown.forEach((element) => {
            const targetId = element.getAttribute('data-target');
            const height = element.getAttribute('data-height') || 0;
            const target = document.getElementById(targetId);

            doublePullDown(element, height);
          });
        }

        //商品を探す　検索するボタンの活性化をリセット
        searchButtonDisabledToggle();
      },
      error: () => {
        console.error('ajax通信に失敗しました。');
      },
    });
  };

  //思い出の作品
  const renderMemory = (containerSelectId, containerId, ctgryNameList, yyyyList, dataMap) => {
    // ジャンル、年のセレクトボックスを生成
    const containerSelectCategory = document.getElementById(`${containerSelectId}-category`);
    // 既存の内容をクリア
    containerSelectCategory.innerHTML = '';
    // カテゴリーのHTMLを生成
    let selectedCtgryName = ctgryNameList.find((item) => item.ctgryname === '男性向けコミック')?.ctgryname || ctgryNameList[0]?.ctgryname;

    let categoryHtml = `
      <div class="c-select js-select js-memory-select" data-target="js-bottomNavCategory" tabindex="0">
        <div class="c-select__label js-selectLabel js-memory-selectLabel c-bottom-nav__select-label" data-target="js-bottomNavCategory">
          ${selectedCtgryName}
        </div>
        <div class="c-select__option-container c-bottom-nav__select-option" id="js-bottomNavCategory">
    `;

    ctgryNameList.forEach((item, index) => {
      const ctgryname = item.ctgryname;
      const id = `bottomNavCategory${index + 1}`;
      const isChecked = ctgryname === selectedCtgryName ? 'checked' : '';

      categoryHtml += `
        <div>
          <input type="radio" name="search-category" value="${ctgryname}" data-value="${ctgryname}" id="${id}" class="js-selectOption js-memory-selectOption" ${isChecked}>
          <label class="c-select__options" for="${id}">${ctgryname}</label>
        </div>
      `;
    });

    categoryHtml += `
        </div>
      </div>
    `;

    // セレクトボックスを containerSelectCategory に追加
    containerSelectCategory.innerHTML += categoryHtml;

    // 年代のHTMLを生成
    const containerSelectGeneration = document.getElementById(`${containerSelectId}-generation`);
    // 既存の内容をクリア
    containerSelectGeneration.innerHTML = '';
    let selectedYear = yyyyList.find((item) => item.yyyy === 2000)?.yyyy || yyyyList[0]?.yyyy;

    let generationHtml = `
      <div class="c-select js-select js-memory-select" data-target="js-bottomNavGeneration" tabindex="0">
        <div class="c-select__label js-selectLabel js-memory-selectLabel c-bottom-nav__select-label" data-target="js-bottomNavGeneration">
          ${selectedYear}年
        </div>
        <div class="c-select__option-container c-bottom-nav__select-option" id="js-bottomNavGeneration">
    `;

    yyyyList.forEach((item, index) => {
      const yyyy = item.yyyy;
      const displayText = `${yyyy}年`; // 表示用のテキスト
      const id = `bottomNavGeneration${index + 1}`;
      const isChecked = yyyy === selectedYear ? 'checked' : '';

      generationHtml += `
        <div>
          <input type="radio" name="search-generation" value="${yyyy}年" data-value="${yyyy}" id="${id}" class="js-selectOption js-memory-selectOption" ${isChecked}>
          <label class="c-select__options" for="${id}">${displayText}</label>
        </div>
      `;
    });

    generationHtml += `
        </div>
      </div>
    `;

    // セレクトボックスとボタンを containerSelect に追加
    containerSelectGeneration.innerHTML += generationHtml;

    // オーバーレイとモーダルの順番を変更する処理
    const modal = document.getElementById(containerId); // モーダルの要素
    const overlay = document.getElementById('overlay'); // オーバーレイの要素

    if (modal && overlay) {
      // モーダルの親要素を取得
      const parentElement = modal.parentNode;

      // オーバーレイを削除してモーダルの後に追加
      parentElement.removeChild(overlay);
      parentElement.insertBefore(overlay, modal.nextSibling);
    }

    // イベントリスナーを設定するために少し遅延を加える
    setTimeout(() => {
      // ジャンル部分
      // 特定のセレクトボックスのクリックイベントリスナーを追加
      const selectLabels = containerSelectCategory.querySelectorAll('.js-memory-selectLabel');
      selectLabels.forEach((label) => {
        label.addEventListener('click', (event) => {
          const parent = event.target.closest('.c-select');
          const optionContainer = parent.querySelector('.c-select__option-container');

          // // オプションの表示/非表示を切り替え
          // if (optionContainer.style.display === 'block') {
          //   optionContainer.style.display = 'none';
          // } else {
          //   optionContainer.style.display = 'block';
          // }
        });
      });
      // 特定のセレクトオプションの変更イベントリスナーを追加
      const selectOptions = containerSelectCategory.querySelectorAll('.js-memory-selectOption');
      selectOptions.forEach((option) => {
        option.addEventListener('change', (event) => {
          const name = event.target.getAttribute('name');
          const selectedOption = containerSelectCategory.querySelector(`input[name="${name}"]:checked`);
          if (selectedOption) {
            const selectLabel = selectedOption.closest('.c-select').querySelector('.js-selectLabel');
            selectLabel.textContent = selectedOption.value; // 選択した値をラベルに表示
          }
        });
      });

      // 年代部分
      // 特定のセレクトボックスのクリックイベントリスナーを追加
      const selectGenLabels = containerSelectGeneration.querySelectorAll('.js-memory-selectLabel');
      selectGenLabels.forEach((label) => {
        label.addEventListener('click', (event) => {
          const parent = event.target.closest('.c-select');
          const optionContainer = parent.querySelector('.c-select__option-container');

          // // オプションの表示/非表示を切り替え
          // if (optionContainer.style.display === 'block') {
          //   optionContainer.style.display = 'none';
          // } else {
          //   optionContainer.style.display = 'block';
          // }
        });
      });
      // 特定のセレクトオプションの変更イベントリスナーを追加
      const selectGenOptions = containerSelectGeneration.querySelectorAll('.js-memory-selectOption');
      selectGenOptions.forEach((option) => {
        option.addEventListener('change', (event) => {
          const name = event.target.getAttribute('name');
          const selectedGenOption = containerSelectGeneration.querySelector(`input[name="${name}"]:checked`);
          if (selectedGenOption) {
            const selectLabel = selectedGenOption.closest('.c-select').querySelector('.js-selectLabel');
            selectLabel.textContent = selectedGenOption.value; // 選択した値をラベルに表示
          }
        });
      });
    }, 0); // 0ミリ秒の遅延で次のイベントループで実行
  };

  // 思い出の作品データ更新
  const renderMemoryData = (containerId, memoryDataList) => {
    const container = document.getElementById(containerId);
    container.innerHTML = '';
    let datahtml = ``;
    if (!Array.isArray(memoryDataList)) {
      datahtml = `
            <li>
              <p class="l-bottom-nav__ranking-text">
                作品がありません<br />
                他の条件で探してみましょう！
              </p>
            </li>
        `;
    } else {
      memoryDataList.forEach((product, index) => {
        datahtml += `
          <li class="c-bottom-nav__ranking">
            <span class="c-bottom-nav__rank c-bottom-nav__rank--${index + 1}">${index + 1}</span>
            <div class="c-bottom-nav__ranking-img">
              <img src="${product.imgUrl}" alt="${product.title}" />
            </div>
            <div class="c-bottom-nav__ranking-product">
              <p class="c-bottom-nav__ranking-product-name">
                <a href="/detail/${product.cmdtycode}/" class="c-bottom-nav__ranking-product-link">${product.title}</a>
              </p>
              <div class="c-bottom-nav__ranking-product-info">
                <ul class="c-bottom-nav__ranking-tag-list">
                  <li class="c-bottom-nav__ranking-tag c-bottom-nav__ranking-tag--red">${product.ctgryname}</li>
                  <li class="c-bottom-nav__ranking-tag c-bottom-nav__ranking-tag--orange">${product.lrackname}</li>
                </ul>
                <span class="c-bottom-nav__ranking-product-price">${product.usedprice}<span class="c-bottom-nav__ranking-product-yen">円</span><span class="c-bottom-nav__ranking-product-text">(税込)</span></span>
              </div>
            </div>
          </li>
        `;
      });
    }
    container.innerHTML = datahtml;
  };

  // 絞り込み
  const renderSearch = (containerId, ctgryMap, lrackMap) => {
    if (!lrackMap || typeof lrackMap !== 'object') {
      console.error('Invalid lrackMap:', lrackMap);
      return;
    }
    const container = document.getElementById(containerId);
    container.innerHTML = '';

    const keys = Object.keys(lrackMap); // tagsMapのキーを配列に変換

    // desiredOrderで指定された順序にkeysを並べ替える
    const desiredOrder = ['1002', '1001', '1011', '5001', '7001', '3001']; // 希望の順序にカテゴリIDを追加
    keys.sort((a, b) => desiredOrder.indexOf(a) - desiredOrder.indexOf(b));

    keys.forEach((category, index) => {
      const indexct = index + 1;
      const lrackList = lrackMap[category];
      const categoryName = ctgryMap[category]; // ctgryMapからカテゴリ名を取得

      // 最初のカテゴリにはis-activeクラスを適用、それ以降はcloseクラスを適用
      const isActiveClass = indexct === 1 ? 'is-active' : '';
      const closeClass = indexct !== 1 ? 'c-bottom-nav__sort-genre-container--close' : '';

      const categoryHtml = `
                <li class="c-bottom-nav__sort-tab-list">
                  <div class="c-bottom-nav__sort-tab js-navPullDown ${isActiveClass}" data-target="js-bottomNavSortCategory${indexct}">${categoryName}</div>
                  <div class="c-bottom-nav__sort-genre-container ${closeClass}" id="js-bottomNavSortCategory${indexct}">
                    <ul class="c-bottom-nav__sort-genre-list">
                      ${lrackList
                        .map(
                          (lrack, index) => `
                        <li class="c-bottom-nav__sort-genre">
                          <input name="sort-${containerId}-${category}" type="radio" class="c-checkbox" data-cat-val="${category}" data-lrack-val="${lrack.lrackcode}" id="js-bottomNavSortGenre${category}${index}" />
                          <label for="js-bottomNavSortGenre${category}${index}">
                            <span class="c-checkbox__label">${lrack.lrackname}</span>
                          </label>
                        </li>
                      `,
                        )
                        .join('')}
                    </ul>
                  </div>
                </li>
              `;

      container.innerHTML += categoryHtml;

      setEventListeners();
    });

    // イベントリスナーを設定する関数
    function setEventListeners() {
      const headers = document.querySelectorAll('.c-bottom-nav__sort-tab');
      const containers = document.querySelectorAll('.c-bottom-nav__sort-genre-container');

      headers.forEach((header) => {
        toggleContainerHeight(header, containers, 0);
      });
    }

    // ページロード時にHTML生成を実行
    document.addEventListener('DOMContentLoaded', () => {
      generateHTML();
    });

    //商品を探す　チェックを付けた時に検索するボタンを活性化させる
    $('.c-checkbox').click(function () {
      searchButtonDisabledToggle();
    });

    //商品を探す　検索文字入力監視。入力があれば検索するボタンを活性化させる
    $('#js-bottomNavWord').change(function () {
      searchButtonDisabledToggle();
    });
  };

  // ネットオフのおすすめ
  // 人気タグ・新着タグ
  const renderTagList = (containerId, tagsList) => {
    if (!tagsList || typeof tagsList !== 'object') {
      console.error('Invalid tagsList:', tagsList);
      return;
    }
    const container = document.getElementById(containerId);
    container.innerHTML = '';

    tagsList.forEach((tag, index) => {
      const indexct = index + 1;
      const tagHtml = `
                <li>
                  <a href="/tag/?tagid=${tag.tagid}" class="c-bottom-nav__tag"><span class="c-bottom-nav__tag-label">${tag.tagname}</span></a>
                </li>
      `;
      container.innerHTML += tagHtml;
    });
  };

  // 商品を探すボタンのクリックイベントを追加
  const searchButton = document.getElementById('memory-ajax');
  if (searchButton) {
    searchButton.addEventListener('click', () => {
      const searchModal = document.getElementById('js-searchModal');
      if (searchModal && searchModal.classList.contains('is-active')) {
        // 閉じるを押したときはAPIを呼ばない
        return;
      }
      const targetTab = $('input:radio[name="bottom-nav-tab"]:checked').data('target');
      if (targetTab) {
        switch (targetTab) {
          case 'js-bottomNavTab3':
            handleTabClick('taglist', null, '1002');
            break;
          case 'js-bottomNavTab2':
            handleTabClick('search', null, null);
            break;
          case 'js-bottomNavTab1':
            handleTabClick('memory', null, null);
            break;
        }
      } else {
        handleTabClick('memory', null, null);
      }
    });
  } else {
    console.error("Element with ID 'memory-ajax' not found.");
  }

  // 人気タグ
  document.querySelectorAll('.popularCategoryOption').forEach((element) => {
    element.addEventListener('change', (event) => {
      const dataValue = event.target.getAttribute('data-value');
      handleTabClick('popularTagsList', null, dataValue);
    });
  });
  // 新着タグ
  document.querySelectorAll('.newCategoryOption').forEach((element) => {
    element.addEventListener('change', (event) => {
      const dataValue = event.target.getAttribute('data-value');
      handleTabClick('newTagsList', null, dataValue);
    });
  });
  // 思い出の作品検索
  document.getElementById('memory-submit-btn').addEventListener('click', function () {
    //思い出の品を取得。
    gwtMemory();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  //ブラウザバック対策 初期設定でネットオフのおすすめをチェックするようにする
  setTimeout(() => {
    $('input:radio[name="bottom-nav-tab"]').prop('checked', false);
    $('input:radio[name="bottom-nav-tab"]').eq(1).prop('checked', true);
    const targetTab = document.getElementById('js-bottomNavTab3');
    targetTab.classList.add('is-active');
  }, '500');
  // 検索を実行する関数
  const executeSearch = () => {
    // 全てのチェックボックスを取得
    const checkboxes = document.querySelectorAll('.c-checkbox');

    let catVal = '';
    let lrackVal = '';
    // チェックされているチェックボックスのdata-cat-valとdata-lrack-valを取得
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        catVal = checkbox.getAttribute('data-cat-val');
        lrackVal = checkbox.getAttribute('data-lrack-val');
      }
    });

    // デバッグ情報をコンソールに出力
    // console.log('Selected Categories:', catVal);
    // console.log('Selected Genres:', lrackVal);

    // 隠しフィールドの値を更新
    document.getElementById('hiddenCat').value = catVal;
    document.getElementById('hiddenGenre').value = lrackVal;

    // フォームをサブミット
    document.querySelector('#js-bottomNavSortForm').submit();

    console.log('buttonクリック');
    //商品を探す　検索ボタンの活性化処理
    searchButtonDisabledToggle();
  };

  // 外側のボタンにイベントリスナーを追加
  // 条件を解除するボタン
  document.querySelector('.c-button-nav__clear-button').addEventListener('click', function () {
    clearAllInput(document.getElementById('js-bottomNavTab2'));
    searchButtonDisabledToggle();
  });
  // 検索するボタン（有効化時）
  document.querySelector('.c-button--next-green.c-button-nav__search-button').addEventListener('click', executeSearch);

  // フォーム内のボタンにイベントリスナーを追加
  document.querySelector('.c-bottom_nav__input-button').addEventListener('click', executeSearch);
});

function handleButtonClick() {
  const word = document.getElementById('wordInput').value;
  handleTabClick('tagSearch', null, word);
}
// handleButtonClick関数をグローバルスコープに登録
window.handleButtonClick = handleButtonClick;

//商品を探す　検索するボタンの活性化を変えるToggle
function searchButtonDisabledToggle() {
  const hasCheckbox = $('.c-checkbox:checked').length;
  const wordValue = $('#js-bottomNavWord').val();
  if (hasCheckbox > 0 || wordValue.length > 0) {
    $('.c-button-nav__search-button').prop('disabled', false);
  } else if (hasCheckbox === 0 && wordValue.length === 0) {
    $('.c-button-nav__search-button').prop('disabled', true);
  }
}

function gwtMemory() {
  // 選択されたカテゴリーを取得（data-valueから）
  const selectedCategoryElement = document.querySelector('input[name="search-category"]:checked');
  const selectedCategory = selectedCategoryElement ? selectedCategoryElement.dataset.value : '';

  // 選択された年代を取得（data-valueから）
  const selectedGenerationElement = document.querySelector('input[name="search-generation"]:checked');
  const selectedGeneration = selectedGenerationElement ? selectedGenerationElement.dataset.value : '';

  // Ajaxリクエストを送信する
  handleTabClick('memoryData', selectedCategory, selectedGeneration);
}
